// Small helpers for the Store Check screen.

const ET = { timeZone: 'America/New_York' };

export function clock(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('en-US', { ...ET, hour: 'numeric', minute: '2-digit' });
}

export function dayAndClock(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleString('en-US', { ...ET, weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

// An area's name as a person would read it: front_counter → Front counter.
export function areaLabel(name) {
  const s = String(name || '').replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// The area names in an area map: every line that starts "- name:".
export function areasInMap(text) {
  const names = [];
  for (const line of String(text || '').split('\n')) {
    const m = /^\s*-\s*([a-z][a-z0-9_]{1,39})\s*:/.exec(line);
    if (m && !names.includes(m[1])) names.push(m[1]);
  }
  return names;
}

// Keep each area's "show its status" choice when the map is edited; a new area starts off.
export function mergeAreas(names, previous) {
  const was = new Map((previous || []).map((a) => [a.name, a.show_status]));
  return names.map((name) => ({ name, show_status: was.get(name) === true }));
}

export const TONE = {
  clear: { bg: '#e8f5e9', fg: '#2e7d32' },
  flagged: { bg: '#fff3e0', fg: '#b45309' },
  unseen: { bg: '#eceff1', fg: '#546e7a' },
  waiting: { bg: '#e3f2fd', fg: '#1565c0' },
  offline: { bg: '#eceff1', fg: '#546e7a' },
  unread: { bg: '#eceff1', fg: '#546e7a' },
};
